module.exports = __webpack_public_path__ + "img/品牌图.435f674b.png";